import { createFileRoute } from "@tanstack/react-router";
import { SolutionsIndexPage } from "@/components/solutions/SolutionsIndexPage";
import { solutionsIndexSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => solutionsIndexSeo(loaderData?.href ?? "/solutions"),
  component: SolutionsIndexPage,
});
